import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import Badge from '../components/ui/Badge';

export default function Playbooks() {
  return (
    <section>
      <SectionHeader id="playbooks" title="4-8. Sales Strategy & Playbooks" subtitle="How to navigate the deal, qualify, and run discovery." />
      
      <div className="space-y-8">
        
        {/* Section 4: Routing Logic */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 border-l-4 border-blue-500 pl-3">Routing: What to Pitch When</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm text-slate-300">
              <thead className="bg-slate-800 text-slate-400 uppercase">
                <tr>
                  <th className="p-3">Buyer Situation</th>
                  <th className="p-3">Lead With</th>
                  <th className="p-3">Why?</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-700">
                <tr>
                  <td className="p-3 font-medium text-white">Low traffic, thin content section</td>
                  <td className="p-3"><Badge type="confirmed">The Pitch Feed</Badge></td>
                  <td className="p-3">They need volume to rank and attract users first.</td>
                </tr>
                <tr>
                  <td className="p-3 font-medium text-white">High traffic, low time-on-page</td>
                  <td className="p-3"><Badge type="confirmed">ScoreWidget</Badge></td>
                  <td className="p-3">They have eyeballs, they need to monetize them longer.</td>
                </tr>
                <tr>
                  <td className="p-3 font-medium text-white">Sports App looking for stickiness</td>
                  <td className="p-3"><Badge type="recommended">Bundle: Feed + Widget</Badge></td>
                  <td className="p-3">Apps need constant updates. Raw data + news is the ultimate combo.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Section 6: Pain Points */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 border-l-4 border-red-500 pl-3">Identifying Buyer Pain</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-slate-800 p-4 rounded-lg">
              <h4 className="text-red-400 font-bold mb-1">Pain: "We can't cover every game."</h4>
              <p className="text-sm text-slate-300 mb-2">They miss out on long-tail SEO traffic for tier-2 leagues.</p>
              <div className="text-xs">
                <span className="text-slate-500 block">Solution:</span>
                <span className="text-blue-400 font-medium">Pitch Feed (Automated scale)</span>
              </div>
            </div>
            <div className="bg-slate-800 p-4 rounded-lg">
              <h4 className="text-red-400 font-bold mb-1">Pain: "APIs are too hard to integrate."</h4>
              <p className="text-sm text-slate-300 mb-2">Dev team is a bottleneck; they have data but no UI.</p>
              <div className="text-xs">
                <span className="text-slate-500 block">Solution:</span>
                <span className="text-blue-400 font-medium">ScoreWidget (Plug & play UI)</span>
              </div>
            </div>
          </div>
        </div>

        {/* Section 8: Discovery */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4 border-l-4 border-emerald-500 pl-3">Crucial Discovery Questions</h3>
          <ul className="space-y-3">
            <li className="bg-slate-800/50 p-3 rounded border border-slate-700">
              <span className="text-emerald-400 font-bold block mb-1">To uncover Content Needs:</span>
              <span className="text-slate-300 italic text-sm">"How much of your editorial budget is spent on routine match previews versus high-value opinion pieces?"</span>
            </li>
            <li className="bg-slate-800/50 p-3 rounded border border-slate-700">
              <span className="text-emerald-400 font-bold block mb-1">To uncover Widget Needs:</span>
              <span className="text-slate-300 italic text-sm">"When a user lands on a match article, what's keeping them there during the actual 90 minutes of the game?"</span>
            </li>
            <li className="bg-slate-800/50 p-3 rounded border border-slate-700">
              <span className="text-purple-400 font-bold block mb-1">Transition Line (Feed to Widget):</span>
              <span className="text-slate-300 italic text-sm">"Since you're scaling up content with the Feed, the next logical step is making those pages interactive. Most of our Feed clients drop ScoreWidget onto those exact same pages to double session length."</span>
            </li>
          </ul>
        </div>

      </div>
    </section>
  );
}